<template>
  <header class="page-header bg-brand-gradient top-fixed px-0" role="banner">
    <div class="d-flex ml-0 page-logo bg-dark">
      <header-logo :to="{ name: 'home', params: { view: 'week' }, query: this.$route.query}" />
    </div>

    <div class="ml-auto mr-0 d-flex menu-icon-center">
      <div v-for="item in menuItems" :key="item.name">
        <router-link
          class="header-icon"
          active-class="active"
          :to="{ name: item.name, params: item.params ? item.params : {} }"
        >
          <i v-if="item.icon" class="fal fa-fw mr-2" :class="item.icon" />

          <span class="nav-link-text">{{ $t(item.title) }}</span>
        </router-link>
      </div>
    </div>

    <div class="user-box" :class="{ show: profileVisible }" v-on-clickaway="hideProfileMenu">
      <a
        href="javascript:void(0)"
        title="drlantern@gotbootstrap.com"
        class="header-icon d-flex align-items-center justify-content-center ml-lg-2"
        aria-expanded="true"
        @click="toggleProfileMenu"
      >
        <img class="profile-image rounded-circle" :alt="fullName" :src="avatarSrc" />

        <span class="ml-1 mr-1 text-truncate text-truncate-header hidden-xs-down">{{ fullName }}</span>

        <i
          class="ni ni-chevron-down hidden-xs-down"
          :class="{ 'ni-chevron-down': profileVisible, 'ni-chevron-up': profileVisible }"
        />
      </a>

      <div
        class="dropdown-menu dropdown-menu-animated dropdown-lg show mr-0 py-0"
        style="position: absolute; top: 64px; right:0; left:auto;"
      >
        <div class="dropdown-header bg-trans-gradient d-flex flex-row py-2 rounded-0">
          <div class="d-flex flex-row align-items-center my-0 color-white">
            <span class="mr-2">
              <img class="rounded-circle profile-image" :alt="fullName" :src="avatarSrc" />
            </span>

            <div class="info-card-text">
              <div class="fs-lg text-truncate text-truncate-lg">{{ fullName }}</div>

              <span class="text-truncate text-truncate-md opacity-80">{{ email }}</span>
            </div>
          </div>
        </div>

        <div class="dropdown-divider m-0" />

        <check-permission permissions="USER.GET" :entityType="entityType" :entityId="profileId">
          <router-link class="dropdown-item" :to="{ name: 'myProfile' }">{{ $t('menu.profile') }}</router-link>
        </check-permission>

        <check-permission permissions="SETTING.LIST">
          <router-link
            class="dropdown-item"
            :to="{ name: 'configuration' }"
          >{{ $t('menu.configuration') }}</router-link>
        </check-permission>

        <div class="dropdown-multilevel dropdown-multilevel-left">
          <div class="dropdown-item">{{ $t('buttons.language') }}</div>

          <div class="dropdown-menu change-lang">
            <a
              v-for="lang in languages.list"
              :key="lang.value"
              class="dropdown-item"
              href="#"
              :class="{ active: languages.selected.value === lang.value }"
              @click.prevent="setLang(lang.value)"
            >
              <span :class="lang.value">{{ lang.label }}</span>
            </a>
          </div>
        </div>

        <div class="dropdown-divider m-0" />

        <a
          class="dropdown-item fw-500 pt-3 pb-3 logout"
          href="javascript:void()"
          @click.prevent="logout"
        >
          <span data-i18n="drpdwn.page-logout">{{ $t('buttons.log-out') }}</span>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { mapState } from 'vuex';

import { lagnuagesMixin } from '@/mixins/languages';
import { gravatarUrl } from '@/utils/media';
import { getProfileId } from '@/utils';
import { TableName } from '@/enums/tableName.enum';
import HeaderLogo from './HeaderLogo';
import ChangeLanguage from '../ChangeLanguage';

// @vuese
// Nagłówek stron po zalogowaniu
// @group Layout
export default {
  name: 'Header',
  mixins: [clickaway, lagnuagesMixin],
  components: { ChangeLanguage, HeaderLogo },
  data() {
    return {
      entityType: TableName.Profile,
      profileId: getProfileId(),
      profileVisible: false
    };
  },
  created() {
    this.$store.dispatch('setMobileNav', this.bodyElement.classList.contains('mobile-nav-on'));
  },
  computed: {
    title() {
      if (this.$route.meta && this.$route.meta.title) {
        return this.$route.meta.title;
      }
      return '';
    },
    bodyElement() {
      return document.body;
    },
    ...mapState({
      appTitle: state => state.system.appTitle,
      mobile: state => state.mobile.mobileNav,
      menuItems: state => state.menu.menu,
      avatarSrc: state => state.auth.data && gravatarUrl(state.auth.data.email),
      fullName: state => state.auth.data && `${state.auth.data.firstName} ${state.auth.data.lastName}`,
      email: state => state.auth.data && state.auth.data.email
    })
  },
  watch: {
    mobile(to) {
      if (to) {
        this.bodyElement.classList.add('mobile-nav-on');
      } else {
        this.bodyElement.classList.remove('mobile-nav-on');
      }
    }
  },
  methods: {
    // @vuese
    // Ukrywa menu profilu po kliknięciu poza
    hideProfileMenu() {
      this.profileVisible = false;
    },
    // @vuese
    // Wylogowuje użytkwonika
    logout() {
      this.$store.dispatch('showConfirm', {
        title: this.$t('titles.logout'),
        description: this.$t('titles.logoutMessage'),
        onSuccess: () => {
          this.$store.dispatch('auth/logout');
          this.$router.push({ name: 'login' });
        }
      });
    },
    // @vuese
    // Ukrywa/pokazuje menu
    toggleNavigationState() {
      this.bodyElement.classList.toggle('nav-function-hidden');
    },
    // @vuese
    // Ukrywa/pokazuje menu
    toggleMobile() {
      this.$store.dispatch('setMobileNav');
    },
    // @vuese
    // Ukrywa/pokazuje profil
    toggleProfileMenu() {
      this.profileVisible = !this.profileVisible;
    }
  }
};
</script>

<style>
.user-box {
  font-weight: 500;
  cursor: pointer;
  background-color: rgba(26, 62, 90, 0.3);
  transition: background-color 0.2s ease-in-out;
}
.user-box:hover {
  background-color: rgba(26, 62, 90, 0.6);
}
@media (min-width: 768px) {
  .user-box {
    width: 12rem;
  }
}

.user-box .header-icon {
  color: white !important;
  cursor: pointer;
}
.logout {
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
}
.dropdown-item.active,
.dropdown-item:active {
  color: #000000;
  background-color: rgb(227, 245, 234);
}
</style>
